<template>
    <div>
        <el-dialog title="Оформить заказ" :visible.sync="modal" width="30%">
            <div v-if="step === 1 || !form.tasks || !form.time">
                <p class="mb-5">После оформления заказа, заявки на размещение рекламы будут отправлены рекламодателям</p>
                <el-alert class="mb-2" :title="error.text" v-if="error.status" type="error"></el-alert>

                <div class="form-group mb-2">
                    <label>Задача для публикации</label>
                    <el-select v-model="form.tasks[0]" :multiple="false" placeholder="Задача для публикации">
                        <el-option v-for="task in tasks" :key="task.id" :label="task.title" :value="task.id">
                            <el-tag class="el-pl-type" v-if="task.type === 1 && !task.ads" type="info" size="mini" effect="plain">нативная</el-tag>
                            <el-tag class="el-pl-type" v-if="task.type === 1 && task.ads" size="mini" effect="plain">прямая</el-tag>
                            <el-tag class="el-pl-type" v-if="task.type === 2" type="warning" size="mini" effect="plain">история</el-tag>
                            {{ task.title }}
                        </el-option>
                    </el-select>
                </div>

                <div class="form-group mb-5">
                    <label>День публикации</label>
                    <el-date-picker :picker-options="datePickerOptions" start-placeholder="День начала" end-placeholder="День конца" type="daterange" range-separator="До" v-model="form.day" format="dd.MM.yyyy" value-format="dd.MM.yyyy" placeholder="День выхода поста"></el-date-picker>
                </div>
                <div class="form-group mb-5">
                    <label>Время публикации</label>
                    <el-time-picker  arrow-control value-format="HH:mm" is-range :format="'HH:mm'" v-model="form.time" range-separator="До" start-placeholder="Время начала" end-placeholder="Время конца"></el-time-picker>
                </div>

                <el-button v-if="!error.status || !form.tasks || !form.time" type="primary" class="btn-block" @click="step = 2">Далее</el-button>
                <el-button v-else type="primary" class="btn-block" :disabled="true">Далее</el-button>
            </div>
            <div v-else>
                <p class="mb-5">После оформления заказа, заявки на размещение рекламы будут отправлены рекламодателям</p>
                <selectedPlatformsList :selected="selected" :type="tasksType" :countTasks="form.tasks.length" @deleteItemFromCart="deleteItemFromCart"></selectedPlatformsList>
                <br>
                <div>
                    <el-button type="primary" class="btn-block" @click="createOrder()">Оплатить</el-button>
                </div>
                <div class="text-center">
                    <a class="back" @click="step = 1">
                        Вернуться назад
                    </a>
                </div>
            </div>
            <div class="overlay" v-if="form.loading">
                <div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import selectedPlatformsList from './selectedPlatformsList'

    export default {
        name: "createRequestsModel",
        props: {
            selected: Array,
            tasks: Array
        },
        data() {
            return {
                modal: false,
                step: 1,
                datePickerOptions: {
                    disabledDate (date) {
                        let day = 1000*60*60*24;
                        return date <= new Date() - day;
                    },
                    firstDayOfWeek: 1,
                },
                form: {},
                error: {},
                tasksType: 'native',
            }
        },
        methods: {
            initOrderModal() {
                this.step = 1;
                this.form = {
                    tasks: [],
                    time: ['12:00', '23:59'],
                    day: [],
                    loading: false,
                };
                this.error = {
                    status: false,
                    text: ''
                };
                this.modal = true;
                this.setInitTime();
            },
            setInitTime() {
                let initTime = new Date((new Date()).getTime() + 35 * 60000);
                this.form.time[0] = initTime.getHours() + ':' + initTime.getMinutes();
            },
            getType(task) {
                if (!task) return;

                if (task.type === 1 && !task.ads) {
                    return 'native';
                }
                if (task.type === 1 && task.ads) {
                    return 'direct';
                }
                if (task.type === 2) {
                    return 'story';
                }
            },
            checkTypes(tasks) {
                let last = this.getType(tasks[0]);
                tasks.forEach((task) => {
                    let curr = this.getType(task);
                    if (last !== curr) {
                        throw 'Все задачи должны иметь одинаковый тип';
                    }
                    last = curr;
                })
            },
            checkPlatformsTypes(tasks) {
                let taskType = this.getType(tasks[0]);
                this.tasksType = taskType;

                this.selected.forEach((platform) => {
                    if (taskType === 'native' && !platform.posts) {
                        throw 'Некоторые из площадок не могут разметить посты содержащие нативную рекламу!';
                    }
                    if (taskType === 'direct' && !platform.directAds) {
                        throw 'Некоторые из площадок не могут разметить посты содержащие прямую рекламу!';
                    }
                    if (taskType === 'story' && !platform.stories) {
                        throw 'Некоторые из площадок не могут размещать истории!';
                    }
                });
            },
            async checkErrors() {
                this.error = {status: false, text: ''};

                let tasks = [];
                await this.form.tasks.forEach((id) => {
                    tasks.push(this.tasks.find((item) => item.id === id));
                });

                if (!tasks) {
                    return;
                }

                try {
                    this.checkTypes(tasks);
                    this.checkPlatformsTypes(tasks);
                } catch (e) {
                    this.error = {
                        status: true,
                        text: e.toString()
                    };
                }
            },
            deleteItemFromCart(item) {
                this.$emit('deleteItemFromCart', item);
            },
            createOrder() {
                let data = this.form;
                data.ids = [];

                this.selected.forEach((item) => {
                    data.ids.push(item.id);
                });

                this.$emit('createOrder', data);
            },
            toStepFirst() {
                this.step = 1;
            }
        },
        watch: {
            'form.tasks'() {
                this.checkErrors();
            }
        },
        components: {
            selectedPlatformsList
        }
    }
</script>

<style scoped>
    .back {
        color: #409eff;
        cursor: pointer;
        display: block;
        margin-top: 14px;
    }
</style>
